<template>
  <div>
    <vs-row vs-justify="center">
      <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="8">
        <step-progress
          v-if="stepList.length > 1"
          :current-step="currentStep"
          :steps="mockedSteps"
          :active-color="colors.primario"
          :active-thickness="0"
          :passive-thickness="0"
          :line-thickness="8"
        />
        <div v-if="stepList.length === 1" class="mt-5" />
      </vs-col>
    </vs-row>
    <vs-row vs-justify="center" v-if="wizardData.fileNumber">
      <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="10">
        <h4 style="color: #662583">Documento #{{wizardData.fileNumber}}</h4>
      </vs-col>
    </vs-row>
    <vs-row vs-justify="center" v-if="wizardData.type === 'file'">
      <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="10">
        <h4 style="color: #662583">Documento</h4>
      </vs-col>
    </vs-row>
    <vs-row vs-justify="center">
      <vs-col vs-w="10">
        <vs-card id="wizard">
          <div slot="header">
            <h3>
              {{currentStepTitle}}
            </h3>
          </div>
          <div>
            <component
              ref="step"
              :is="currentStepComponent"
              :draft="wizardData"
              :lazy="isLazyStep"
              @update-steps="updateSteps"
              @loaded="onStepLoaded"
            />
          </div>
          <div slot="footer" class="mt-4 pt-5">
            <vs-row vs-justify="flex-end">
              <vs-button color="primary" v-if="!isFirstStep" @click="onBack">
                Volver
              </vs-button>
              <CheckPermission
                permission="ED046"
                v-if="wizard.options && wizard.options.includes('flow') && isLastStep"
              >
                <vs-button color="warning" class="ml-2" @click="onFlow">
                  <span>Enviar a Flujo</span>
                </vs-button>
              </CheckPermission>
              <CheckPermission
                permission="ED046"
                v-if="wizard.options && wizard.options.includes('submit')"
              >
                <vs-button
                  data-cy="send"
                  color="success" class="ml-2" @click="onNext"
                  :disabled="blockButton"
                >
                  <span v-if="isLastStep">Enviar</span>
                  <span v-if="!isLastStep">{{nextStepTitle}}</span>
                </vs-button>
              </CheckPermission>
            </vs-row>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
    <b-overlay :show="isLoading" no-wrap />
  </div>
</template>
<script>

import StepProgress from 'vue-step-progress';
import { mapGetters, mapActions } from 'vuex';

import config from './config/wizard';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';

export default {
  components: {
    StepProgress,
    CheckPermission
  },
  data() {
    return {
      blockButton: false,
      currentStep: Number.parseInt(this.$route.query.step || 0, 10),
      wizard: {
        steps: []
      },
      conditionData: {},
      waitStepLoading: true
    };
  },
  computed: {
    ...mapGetters('Approvals', {
      loadingApprovals: 'loading'
    }),
    ...mapGetters('List', [
      'userGroupsState',
      'groupsState'
    ]),
    ...mapGetters('Personalizacion', [
      'colors'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    isFirstStep() {
      return this.currentStep === 0;
    },
    stepList() {
      return this.wizard.steps.filter((step) => (
        !step.condition
        || step.condition(this.conditionData)
      ));
    },
    isLastStep() {
      return this.currentStep >= this.stepList.length - 1;
    },
    mockedSteps() {
      return new Array(this.stepList.length)
        .fill('');
    },
    currentStepSetting() {
      return this.stepList[this.currentStep];
    },
    currentStepTitle() {
      return this.currentStepSetting?.title;
    },
    currentStepComponent() {
      return this.currentStepSetting?.component;
    },
    nextStepTitle() {
      return this.stepList[this.currentStep + 1]?.title;
    },
    isLazyStep() {
      return this.currentStepSetting?.isLazy;
    },
    isLoading() {
      return this.loading
        || (this.isLazyStep && this.waitStepLoading)
        || this.userGroupsState.loading
        || this.loadingApprovals
        || this.groupsState.loading;
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'addWizardData',
      'mergeWizardData',
    ]),
    ...mapActions('List', [
      'fetchUserGroups'
    ]),
    onBack() {
      if (this.isFirstStep) {
        return;
      }

      if (this.currentStepSetting?.draftOnBack) {
        this.mergeWizardData(this.$refs.step.getStepData());
      }

      this.currentStep -= 1;
      this.waitStepLoading = true;
    },
    async onNext() {
      try {
        if (!await this.$refs.step.isValid()) {
          return;
        }

        if (this.isLastStep) {
          this.mergeWizardData(this.$refs.step.getStepData());
          await this.onEnd();
          return;
        }

        this.addWizardData(this.$refs.step.getStepData());

        this.currentStep += 1;
        this.waitStepLoading = true;
        // updateSearchParams({ step: this.currentStep });
      } catch (e) {
        this.blockButton = false;
        console.log('error', e);
      }
    },
    async onEnd(flow) {
      this.blockButton = true;
      const { id } = this.$route.params;
      this.$vs.loading({
        container: '#wizard',
        scale: 0.6
      });
      try {
        const data = this.wizard.documentMapper(
          this.wizardData,
          this.company.iut,
          this.company.razonSocial,
          false,
          flow
        );
        await this.$store.dispatch(`Approvals/${this.wizard.submitAction}`, { // TODO: REVISAR ACA
          id,
          data,
          isDraft: false,
          redirectFlow: flow
        });
        this.blockButton = false;
        this.$vs.loading.close('#wizard > .con-vs-loading');
        await this.$bvToast.toast(
          'Se ha enviado a flujo exitosamente',
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        this.wizard = await config[this.wizardConfig]();
      } catch (e) {
        this.$vs.loading.close('#wizard > .con-vs-loading');
        this.blockButton = false;
        console.log('error', e);
      }
    },
    async onFlow() {
      if (!await this.$refs.step.isValid()) {
        return;
      }

      this.addWizardData(this.$refs.step.getStepData());
      if (this.isLastStep && this.wizard.options.includes('flow')) {
        await this.onEnd(true);
        return;
      }

      this.wizard.currentStep += 1;
      this.waitStepLoading = true;
    },
    updateSteps() {
      this.conditionData = {
        ...this.wizardData,
        ...this.$refs.step.getStepData()
      };
    },
    onStepLoaded() {
      this.waitStepLoading = false;
    }
  },
  async created() {
    if (config[this.wizardConfig]) {
      this.wizard = await config[this.wizardConfig]();
    }
    this.waitStepLoading = this.isLazyStep;
  },
  props: {
    wizardConfig: { type: String },
    wizardData: { type: Object },
    loading: { type: Boolean, default: true }
  }
};
</script>

<style lang="scss">

@import "~vue-step-progress/dist/main.css";

</style>
